import axios from 'axios'
import baseUrl from '../config'
import getToken from '../../utils/getToken'

export const confirmEmail = data => {
  return axios
    .post(`${baseUrl}/confirm-email`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const login = data => {
  return axios
    .post(`${baseUrl}/login`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const requestMagicLink = data => {
  return axios
    .post(`${baseUrl}/request-magic-link`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const magicLogin = data => {
  return axios
    .post(`${baseUrl}/magic-login`, { ...data })
    .then(data => data)
    .catch(err => err)
}

export const register = data => {
  const token = getToken()
  return axios
    .post(`${baseUrl}/register`, { ...data, token })
    .then(responseData => responseData)
    .catch(err => err)
}

export const resetPassword = data => {
  return axios
    .post(`${baseUrl}/reset-password`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const requestConfirmationEmail = data => {
  return axios
    .post(`${baseUrl}/request-confirmation-email`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const requestPasswordReset = data => {
  return axios
    .post(`${baseUrl}/request-password-reset`, data)
    .then(responseData => responseData)
    .catch(err => err)
}

export const generateApiKey = () => {
  const token = getToken()

  return axios
    .post(`${baseUrl}/cli-api-keys`, { token })
    .then(data => data)
    .catch(err => err)
}

export const processOnboarding = data => {
  return axios
    .post(`${baseUrl}/process-onboarding`, data)
    .then(d => d)
    .catch(err => err)
}

export const acceptHostAgreement = () => {
  const token = getToken()

  return axios
    .post(`${baseUrl}/accept-host-agreement`, { token })
    .then(data => data)
    .catch(err => err)
}

export const fetchMyRoles = async opts => {
  const providedToken = opts ? opts.token : null
  const token = providedToken || getToken()
  const params = { token }

  if (opts) {
    Object.keys(opts).map(opt => (params[opt] = opts[opt]))
  }

  const response = await axios.get(`${baseUrl}/my-roles`, { params })
  return response.data
}

export const logout = token => {
  return axios
    .delete(`${baseUrl}/logout`, {
      data: { token }
    })
    .then(() => true)
    .catch(err => err)
}
